import { useQuery } from '@tanstack/react-query';

import { supabase } from '../../api';

const getData = async (page: string) => {
  const { data, error } = await supabase
    .from('discovery_schema')
    .select(`
    *,
    playlist:playlists(*)
  `)
    .order('order')
    .eq('page', page)
    .is('is_active', null)

  if (error) {
    throw new Error(error.message);
  }

  return data;
};

export default function useGetDiscoverySchema(page: string) {
  return useQuery({
    queryKey: ['useGetDiscoverySchema', page],
    queryFn: () => getData(page),
    staleTime: 0,
    cacheTime: 0,
    enabled: !!page,
  });
}
